import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { PampIframeService } from 'src/app/core/services/pamp-iframe.service';
import { Patient, PatientService } from '../../core/api/patient.service';
import { AssessmentComponent } from '../../encounters/assessment/assessment.component';
import { EncounterDashboardComponent } from './../../encounters/encounter-dashboard/encounter-dashboard.component';
import { EyePosition } from './patient-chart/patient-chart.component';

@Component({
  selector: 'csi-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css']
})
export class PatientComponent implements OnInit, OnDestroy {
  public onPatientFileSaved$: Subject<Object> = new Subject<Object>();
  public patient$: Observable<Patient>;

  public showSendQuestionnaireButton = true;
  public isAssessmentActive = false;

  public readonly EyePosition = EyePosition;

  constructor(
    private route: ActivatedRoute,
    private patientService: PatientService,
    private changeDetector: ChangeDetectorRef,
    private pampIframeService: PampIframeService
  ) {}

  ngOnInit() {
    this.patient$ = this.route.data.pipe(
      map((data: any) => data.patient),
      switchMap(patient => {
        const fetchPolicy = 'cache-only';
        return this.patientService.getPatient(
          patient.id,
          true,
          fetchPolicy,
          this.patientService.maxAssessmentsPerPatient
        );
      }),
      untilDestroyed(this)
    );

    this.pampIframeService.showIframe$
      .pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe(isOpen => {
        if (!isOpen) {
          this.fetchPatientAppStatusDirectly();
        }
      });
  }

  private fetchPatientAppStatusDirectly() {
    const patientId = this.patientService.patient ? this.patientService.patient.id : null;
    if (patientId) {
      this.patientService.syncPatientAppStatus(patientId).subscribe(() => {
        this.changeDetector.markForCheck();
      });
    }
  }

  ngOnDestroy() {}

  public onEncountersOutletActivate(
    activeComponent: EncounterDashboardComponent | AssessmentComponent
  ) {
    this.showSendQuestionnaireButton = activeComponent instanceof EncounterDashboardComponent;
    this.isAssessmentActive = activeComponent instanceof AssessmentComponent;

    if (activeComponent instanceof AssessmentComponent) {
      activeComponent.onPatientFileSaved$ = this.onPatientFileSaved$;
    }
    // Needed to prevent changedAfterChecked error
    this.changeDetector.detectChanges();
  }

  public onEncountersOutletDeactivate() {
    this.isAssessmentActive = false;
    this.changeDetector.detectChanges();
  }
}
